/** Whole-percent label for a 0–1 normalized score (e.g. 0.753 → "75%"). */
export function formatNormalizedScorePercent(score) {
  if (score == null || Number.isNaN(Number(score))) {
    return null;
  }

  return `${Math.round(Number(score) * 100)}%`;
}
